// extracted by mini-css-extract-plugin
module.exports = {"altHero":"uj","altProd":"vj","subheading":"wj","subtext":"xj","extrainfo":"yj","copy":"zj","cta":"Aj","disabled":"Bj"};